import React from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'
import useTranslation from 'next-translate/useTranslation'

import styles from './style.module.scss'
import { getImgURL, numberWithOrdinal } from '@shared/utils'
import MyImage from '@shared/components/myImage'

import sixArt from '@assets/images/icon/match/six-art.svg'
import fourArt from '@assets/images/icon/match/four-art.svg'
import wicketArt from '@assets/images/icon/match/wicket-art.svg'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import { useRouter } from 'next/router'

const CommentaryFilter = ({ matchDetail, handleFilterChange }) => {
  const router = useRouter()
  const { eHighLight, nInningNumber } = router?.query

  const { t } = useTranslation()

  const handleFilter = (query) => {
    const obj = {
      pathname: window?.location?.pathname,
      query: query
    }
    if (!query) delete obj.query
    router.push(obj, undefined, { shallow: true })
    handleFilterChange && handleFilterChange(query)
  }
  return (
    <>
      <Nav className={`${styles.commentaryNav} flex-nowrap overflow-auto text-capitalize mb-1 mb-md-0 p-1 br-sm text-start
      ${matchDetail?.sStatusStr === 'live' ? styles.navBottom : styles.noBottomInfoNav}
      ${((matchDetail?.sStatusStr === 'live' && (matchDetail?.oLiveScore?.nRunrate > 0 || matchDetail?.oLiveScore?.sRequiredRunrate))) ? '' : styles.noBottomInfoNav}
      `} variant="pills">
        <Nav.Item>
          <a className={`${styles.item} ${(!eHighLight && !nInningNumber) && styles.active} nav-link h-100 py-1 d-flex align-items-center justify-content-center bg-transparent position-relative`} onClick={() => handleFilter({})}>
            <span className={`${styles.name}`}>{t('common:All')}</span>
          </a>
        </Nav.Item>
        <Nav.Item>
          <a
            className={`${styles.item} ${eHighLight === 'f' && styles.active} nav-link h-100 py-1 d-flex bg-transparent position-relative`}
            onClick={() => handleFilter({ eHighLight: 'f' })}
          >
            <span>
              <span className={`${styles.name} d-block theme-text`}>4</span>
              <span className="font-semi">{t('common:Fours')}</span>
              <span className={`${styles.art} d-block position-absolute top-0 end-0`} style={{ backgroundImage: `url(${fourArt.src})` }}></span>
            </span>
          </a>
        </Nav.Item>
        <Nav.Item>
          <a
            className={`${styles.item} ${eHighLight === 's' && styles.active} nav-link h-100 py-1 d-flex bg-transparent position-relative`}
            onClick={() => handleFilter({ eHighLight: 's' })}
          >
            <span>
              <span className={`${styles.name} d-block theme-text`}>6</span>
              <span className="font-semi">{t('common:Sixes')}</span>
              <span className={`${styles.art} d-block position-absolute top-0 end-0`} style={{ backgroundImage: `url(${sixArt.src})` }}></span>
            </span>
          </a>
        </Nav.Item>
        <Nav.Item>
          <a
            className={`${styles.item} ${eHighLight === 'w' && styles.active} nav-link h-100 py-1 d-flex bg-transparent position-relative`}
            onClick={() => handleFilter({ eHighLight: 'w' })}
          >
            <span>
              <span className={`${styles.name} d-block text-danger`}>W</span>
              <span className="font-semi">{t('common:Wickets')}</span>
              <span className={`${styles.art} d-block position-absolute top-0 end-0`} style={{ backgroundImage: `url(${wicketArt.src})` }}></span>
            </span>
          </a>
        </Nav.Item>
        {matchDetail?.aInning?.map((inning, index) => (
          <Nav.Item key={index + inning?.sShortName}>
            <a
              className={`${styles.item} ${nInningNumber === inning?.nInningNumber?.toString() && styles.active} nav-link h-100 py-1 d-flex bg-transparent position-relative`}
              onClick={() => handleFilter({ nInningNumber: inning?.nInningNumber })}
            >
              <span>
                <span className={`${styles.name} d-block`}>{inning?.nInningNumber}<sup className="text-lowercase">{numberWithOrdinal(inning?.nInningNumber)}</sup></span>
                <span className="font-semi">{t('common:Innings')}</span>
                <span className={`${styles.team} d-block position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle overflow-hidden`}>
                  <MyImage
                    src={getImgURL(inning?.oBattingTeam?.oImg?.sUrl) || teamPlaceholder}
                    alt={inning?.oBattingTeam?.oImg?.sText || ''}
                    width="20"
                    height="20"
                    className="aspect-ratio"
                  />
                </span>
              </span>
            </a>
          </Nav.Item>
        ))}
      </Nav>
    </>
  )
}

CommentaryFilter.propTypes = {
  matchDetail: PropTypes.object,
  handleFilterChange: PropTypes.func
}

export default CommentaryFilter
